import { Select } from '../Select/Select'
import { type FC, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { light } from '@fortawesome/fontawesome-svg-core/import.macro'
import { type ItemGroup } from 'types'
import { Tooltip } from '../Tooltip/Tooltip'

interface ManageGroupsMenuProps {
  itemGroup: Partial<ItemGroup>
  disableDelete?: boolean
  onAdd: (itemGroup: Partial<ItemGroup>) => void
  onCancel: (itemGroup: Partial<ItemGroup>) => void
  onDelete: (itemGroup: Partial<ItemGroup>) => void
  role?: string
}
const Trigger: FC = () => {
  const tooltipRef = useRef(null)
  return (
    <div
      ref={tooltipRef}
      className="font-semibold text-offBlack-dark text-sm px-4 py-2.5 text-center inline-flex items-center"
      id='manageGroupMenu'
    >
      Manage shipments
      <FontAwesomeIcon
        className="ml-2 text-offBlack-dark text-lg"
        icon={light('chevron-down')}
      />
      <Tooltip position="bottom" ref={tooltipRef}>
        <p>Add or delete shipments here</p>
      </Tooltip>
    </div>
  )
}

export const ManageGroupsMenu: FC<ManageGroupsMenuProps> = ({
  itemGroup,
  onAdd,
  onCancel,
  onDelete,
  disableDelete = false,
  role = 'buyer',
}) => {
  const actions = [
    {
      icon: <FontAwesomeIcon className="mr-2" icon={light('plus')} />,
      name: 'Add shipment',
      onClick: () => {
        onAdd(itemGroup)
      },
      disabled: false,
    },
    {
      icon: <FontAwesomeIcon className="mr-2" icon={light('cancel')} />,
      name: 'Cancel shipment',
      onClick: () => {
        onCancel(itemGroup)
      },
      disabled: disableDelete,
      tooltip: disableDelete ? 'Canceling is disabled because items require at least one shipment' : undefined,
    },
  ]

  if (role === 'buyer') {
    actions.push({
      icon: <FontAwesomeIcon className="mr-2" icon={light('trash-alt')} />,
      name: 'Delete shipment',
      onClick: () => {
        onDelete(itemGroup)
      },
      disabled: false,
    })
  }

  return <Select triggerComponent={Trigger} options={actions} />
}
